import ko from '@tko/build.knockout';
import templateMarkup from 'raw-loader!./settings-view.html';
import DataProvider from "../../app/data-framework/data-provider";

    

    function SettingsView(params) {

        var self = this;

        self.dataProvider = DataProvider.getInstance();
        self.route = params.route;
    }

    // This runs when the component is torn down. Put here any logic necessary to clean up,
    // for example cancelling setTimeouts or disposing Knockout subscriptions/computeds.
    SettingsView.prototype.dispose = function () {

    };

    export default { viewModel: SettingsView, template: templateMarkup };


